import { CHAT_FOLLOW_UPS_CACHE_VERSION, CHAT_SUGGESTIONS_CACHE_VERSION } from './chat';

/** Stable cache key tuple for chat suggestions scoped to a PR commit. */
export type ChatSuggestionsQueryKey = readonly [
  'chat-suggestions',
  typeof CHAT_SUGGESTIONS_CACHE_VERSION,
  number,
  number,
  string,
];

/** Builds the React Query cache key used for chat suggestions for a specific PR commit. */
export const chatSuggestionsQueryKey = (
  installationId: number,
  prNumber: number,
  commitHash: string,
): ChatSuggestionsQueryKey => [
  'chat-suggestions',
  CHAT_SUGGESTIONS_CACHE_VERSION,
  installationId,
  prNumber,
  commitHash,
];

export type ChatFollowUpsQueryKey = readonly [
  'chat-follow-ups',
  typeof CHAT_FOLLOW_UPS_CACHE_VERSION,
  string,
  string,
];

/** Builds the per-turn React Query cache key for follow-up suggestions. */
export const chatFollowUpsQueryKey = (
  chatId: string,
  lastAssistantMessageId: string,
): ChatFollowUpsQueryKey => [
  'chat-follow-ups',
  CHAT_FOLLOW_UPS_CACHE_VERSION,
  chatId,
  lastAssistantMessageId,
];

export type ChatWarmQueryKey = readonly ['chat-warm', string, string, number];

/** Builds the React Query cache key used to dedupe best-effort chat context warmups. */
export const chatWarmQueryKey = (params: {
  prKey: string;
  headSha?: string | null;
  codeContentLength?: number | null;
}): ChatWarmQueryKey => [
  'chat-warm',
  params.prKey,
  params.headSha ?? '',
  params.codeContentLength ?? 0,
];

export type PageChatEngineQueryKey = readonly ['page-chat-engine', string | null];

/** Builds the React Query cache key for the agent a pull request page's chat runs on. */
export const pageChatEngineQueryKey = (pullRequestId: string | null): PageChatEngineQueryKey => [
  'page-chat-engine',
  pullRequestId,
];
